export const EXPORT_TYPES = {
	CONTACTS: "contactsexport",
	CAMPAIGN_LOG: "campaignlogexport",
	CAMPAIGN_REPORTS: "campaignsreportsexport",
	SUPPRESSED_EMAILS: "suppressedemailsexport",
	LIST_LOGS: "listlogsexport"
};
